import React from "react";

const DashboardStats = ({ stats, cases, setStatusFilter, statusFilter }) => {
  const statItems = [
    {
      label: "Processing",
      value: "Processing",
      val: stats?.processing ?? cases.filter((c) => c.status === "Processing").length,
      color: "text-amber-400",
    },
    {
      label: "Underwriting",
      value: "Underwriting",
      val: stats?.underwriting ?? cases.filter((c) => c.status === "Underwriting").length,
      color: "text-sky-400",
    },
    {
      label: "Action Required",
      value: "Action Required",
      val: stats?.actionRequired ?? cases.filter((c) => c.status === "Action Required").length,
      color: "text-red-400",
    },
    {
      label: "Approved",
      value: "Approved",
      val: stats?.approved ?? cases.filter((c) => c.status === "Approved").length,
      color: "text-green-400",
    },
    {
      label: "Cleared to Close",
      value: "Cleared to Close",
      val: stats?.clearedToClose ?? cases.filter((c) => c.status === "Cleared to Close").length,
      color: "text-emerald-300",
    },
    {
      label: "Closing",
      value: "Closing",
      val: stats?.closing ?? cases.filter((c) => c.status === "Closing").length,
      color: "text-indigo-300",
    },
    {
      label: "Funded",
      value: "Funded",
      val: stats?.funded ?? cases.filter((c) => c.status === "Funded").length,
      color: "text-teal-300",
    },
    {
      label: "Fall out",
      value: "Fall out",
      val: stats?.fallOut ?? cases.filter((c) => c.status === "Fall out").length,
      color: "text-rose-300",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-8 gap-4 mb-6">
      {statItems.map((stat, i) => (
        <button
          key={i}
          onClick={() => setStatusFilter((prev) => (prev === stat.value ? null : stat.value))}
          className={`dark:bg-slate-900 bg-white border p-5 rounded-lg text-left transition-all duration-200 flex flex-col justify-between min-h-[110px] ${statusFilter === stat.value
            ? "dark:border-sky-500 border-blue-500 dark:bg-sky-500/10 bg-blue-50"
            : "dark:border-slate-800 border-gray-200 dark:hover:border-slate-600 hover:border-gray-300 dark:hover:bg-slate-800/50 hover:bg-gray-50"
            }`}
        >
          <h3 className="dark:text-slate-500 text-gray-600 text-xs font-medium leading-5 uppercase tracking-wider">{stat.label}</h3>
          <p className={`text-2xl font-semibold ${stat.color} leading-none mt-2`}>{stat.val}</p>
        </button>
      ))}
    </div>
  );
};

export default DashboardStats;
